import React from 'react';
import Icon from '@ant-design/icons';

const CommentsSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48" strokeWidth="1">
        <path d="M37.1,5.58H11.18c-4.11,0-7.45,3.34-7.45,7.45v18.76c0,3.6,2.57,6.61,6,7.3v5.89c0,.57.33,1.1.84,1.35.21.1.43.15.66.15.33,0,.66-.11.93-.32l8.83-6.92h16.12c4.11,0,7.45-3.34,7.45-7.45V13.03c0-4.11-3.34-7.45-7.45-7.45ZM41.56,31.79c0,2.45-2,4.45-4.45,4.45h-16.64c-.34,0-.66.11-.93.32l-6.81,5.34v-4.16c0-.83-.72-1.5-1.54-1.5-2.45,0-4.45-2-4.45-4.45V13.03c0-2.45,2-4.45,4.45-4.45h25.92c2.45,0,4.45,2,4.45,4.45v18.76Z" />
        <path d="M17.05,20.53c-.99,0-1.79.8-1.79,1.79s.8,1.79,1.79,1.79,1.79-.8,1.79-1.79-.8-1.79-1.79-1.79Z" />
        <circle cx="24.14" cy="22.32" r="1.79" />
        <path d="M31.24,20.53c-.99,0-1.79.8-1.79,1.79s.8,1.79,1.79,1.79,1.79-.8,1.79-1.79-.8-1.79-1.79-1.79Z" />
    </svg>
);

const CommentsIcon = (props) => {
    return <Icon component={ CommentsSvg } className={ props.className } style={ props.style } />;
};

export default CommentsIcon;
